const downloadInfo = [
  { label: 'ファイル名', value: 'hitotsuzuri_v1.0.2.zip' },
  { label: 'バージョン', value: 'v1.0.2' },
  { label: '対応OS', value: 'Windows 10 / 11 (64bit)' },
  { label: '必要環境', value: '追加のランタイム不要\n（ZIP解凍後、exe単体で動作）' },
  { label: '料金', value: '無料\n（個人・法人・社内業務での利用可）' },
];

const terms = [
  '個人・法人を問わず無料でご利用いただけます。<br />社内業務での利用も可能です。',
  '無料で提供していることは、著作権の放棄や権利の譲渡を意味しません。',
  'PDFの内容やファイル名が、本ソフトウェアによって外部へ送信されることはありません。',
  'しおり・メタデータ・フォームなどの付帯情報は、保持されない場合があります。',
  'パスワード保護されたPDFや破損したPDFは、処理できない場合があります。',
  '重要なファイルは、処理前にバックアップをお取りください。<br />作成されたPDFは必ず内容をご確認ください。',
  '転載・再配布・改変・販売などは禁止です。<br />詳細はアプリ内の「利用規約」をご確認ください。'
];

const HitotsuzuriDownload = () => {

  return (
    <section id="download" className="py-20 bg-[#F0F7EC]">
      <div className="max-w-5xl mx-auto px-6 space-y-10">
        {/* ダウンロード */}
        <div>
          <div className="text-center mb-12">
            <p className="text-[#5DAA68] text-xs font-semibold tracking-[0.2em] uppercase mb-3 font-['Inter']">
              Download
            </p>
            <h4 className="text-2xl md:text-3xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
              ダウンロード
            </h4>
          </div>

          <div className="bg-white rounded-2xl p-5 md:p-10">
            <div className="grid md:grid-cols-2 gap-6 md:gap-10">
              {/* 情報テーブル */}
              <div>
                <div className="space-y-4">
                  {downloadInfo.map((item, index) => (
                    <div key={index} className="flex flex-col sm:flex-row sm:gap-4">
                      <div className="sm:w-28 shrink-0">
                        <span className="text-[13px] font-semibold text-[#89B56B]">
                          {item.label}
                        </span>
                      </div>
                      <div className="flex-1">
                        <p className="text-[13px] text-gray-600 leading-relaxed whitespace-pre-line">
                          {item.value}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-6">
                  <p className="text-[13px] text-gray-600 leading-relaxed">
                    ZIPには次が含まれます。<br />・hitotsuzuri.exe（アプリ本体）<br />・命名リスト_サンプル.xlsx（分割時の保存名指定用・任意）<br />・README.txt
                  </p>
                </div>
              </div>

              {/* ダウンロードボタンと注意書き */}
              <div className="flex flex-col justify-center">
                {/* PC版ボタン */}
                <a
                  href="https://msk2.co.jp/downloads/hitotsuzuri-v1.0.2.zip"
                  download
                  className="hidden sm:inline-flex items-center justify-center px-8 py-4 bg-[#89B56B] text-white text-sm font-bold rounded-lg hover:bg-[#5DAA68] transition-colors cursor-pointer whitespace-nowrap shadow-[0_4px_16px_rgba(137,181,107,0.3)] mb-6"
                >
                  <i className="ri-download-line mr-2"></i>
                  hitotsuzuri_v1.0.2.zip をダウンロード
                </a>

                {/* スマホ版ボタン */}
                <a
                  href="https://msk2.co.jp/downloads/hitotsuzuri-v1.0.2.zip"
                  download
                  className="inline-flex sm:hidden flex-col items-center justify-center px-4 py-3 bg-[#89B56B] text-white text-[13px] font-bold rounded-lg hover:bg-[#5DAA68] transition-colors cursor-pointer shadow-[0_4px_16px_rgba(137,181,107,0.3)] mb-6"
                >
                  <span className="flex items-center">
                    <i className="ri-download-line mr-2"></i>
                    hitotsuzuri_v1.0.2.zipを
                  </span>
                  <span>ダウンロード</span>
                </a>

                <div className="bg-[#FFF8E1] border border-[#FFE082] rounded-lg p-5">
                  <div className="flex items-start gap-3">
                    <div>
                      <p>
                        <i className="ri-alert-line text-lg text-[#F9A825]"></i><span className="text-[13px] font-semibold text-[#F9A825] mb-1">ダウンロード時/初回起動時の警告について</span>
                      </p>
                      <p className="text-[12px] text-gray-600 leading-relaxed">
                        ・ダウンロード時、ブラウザから「一般的にダウンロードされていないファイル」と表示される場合があります。<br />
                        本ソフトウェアは当社が配布するものです。内容をご確認のうえダウンロードしてください。<br />
                        ・本ソフトウェアはコード署名を行っていません。<br />
                        初回起動時に、Windowsやセキュリティソフトから「不明な発行元」などの表示が出る場合があります。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ご利用にあたって */}
        <div className="bg-white rounded-2xl p-5 md:p-10 shadow-[0_4px_24px_rgba(137,181,107,0.08)]">
          <h4 className="text-xl font-bold text-[#89B56B] mb-6 font-['Noto_Sans_JP']">
            ご利用にあたって
          </h4>
          <ul className="space-y-3">
            {terms.map((term, index) => (
              <li key={index} className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#89B56B] shrink-0 mt-2"></span>
                <p className="text-[13px] text-gray-600 leading-relaxed">
                  {term.split('<br />').map((part, i, arr) => (
                    <span key={i}>
                      {part}
                      {i < arr.length - 1 && <br />}
                    </span>
                  ))}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>


    </section>
  );
};

export default HitotsuzuriDownload;